export const MAP_STYLE = [
  {
    "featureType": "administrative",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#29333c"
      }
    ]
  },
  {
    "featureType": "landscape",
    "elementType": "all",
    "stylers": [
      {
        "color": "#e8ded4"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "all",
    "stylers": [
      {
        "saturation": -100
      },
      {
        "lightness": 45
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "all",
    "stylers": [
      {
        "color": "#95cec6"
      },
      {
        "visibility": "on"
      }
    ]
  }
]

$.fn.GoogleMap = function() {
  let self = this
  self.map = undefined
  self.marker = undefined

  self.setCenter = function(lat, lng) {
    if (self.marker != undefined) {
      self.marker.setMap(null)
      self.marker = undefined
    }
    if (lat && lng) {
      self.map.setCenter(new google.maps.LatLng(lat, lng))
      self.marker = new google.maps.Marker({
        position: {
          lat: lat,
          lng: lng,
        },
        icon: {
          url: '/img/elements/pointmap.svg',
          size: new google.maps.Size(32, 45),
  				origin: new google.maps.Point(0, 0),
  				anchor: new google.maps.Point(32 / 2, 45),
  				scaledSize: new google.maps.Size(32, 45),
        },
        map: self.map,
      })
    }
  }

  return function() {
    self.map = new google.maps.Map(self.get(0), {
      styles: MAP_STYLE,
      disableDefaultUI: true,
      zoomControl: true,
      zoom: 11,
      scrollwheel: false,
      draggable: false,
    })

    return self
  }()
}
